import { useMemo } from 'react'
import { RemoveExecutive } from './RemoveExecutive/index.tsx'
import { AddLeader } from './AddLeader/index.tsx'
import { AddManager } from './AddManager/index.tsx'
import { formatName } from '../../../../../app/utils/formatName.ts'
import { BasicAvatar } from '../../../../components/BasicAvatar/index.tsx'
import { Dialog, DialogTrigger } from '@/view/components/ui/dialog.tsx'
import { AddSupervisor } from './AddSupervisors/index.tsx'
import { UserRoleEnum } from '@/app/services/usersService/user.ts'
import { useAuth } from '@/app/hooks/useAuth.ts'

interface ExecutivesCardProps {
  type: UserRoleEnum.MANAGER | UserRoleEnum.SUPERVISOR | UserRoleEnum.LEADER
  executive: {
    name: string
    profileImageUrl: string
  }
  team: string
}
export const ExecutivesCard = ({
  type,
  executive,
  team,
}: ExecutivesCardProps) => {
  const { isAdmin, isManager, isSupport } = useAuth()
  const isEmpty = !executive?.name

  const config = useMemo(() => {
    const executiveMap = {
      [UserRoleEnum.MANAGER]: {
        label: 'Gerente',
        color: '#288F63',
        bg: '#E3F9EC',
        disabled: !(isAdmin || isSupport),
        dialog: <AddManager />,
      },
      [UserRoleEnum.SUPERVISOR]: {
        label: 'Supervisor',
        color: '#A68E38',
        bg: '#FDF3D0',
        disabled: !(isAdmin || isSupport || isManager),
        dialog: <AddSupervisor />,
      },
      [UserRoleEnum.LEADER]: {
        label: 'Líder',
        color: '#C35132',
        bg: '#FFF4ED',
        disabled: !(isAdmin || isSupport || isManager),
        dialog: <AddLeader />,
      },
    }

    return executiveMap[type]
  }, [isAdmin, isManager, isSupport, type])

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-2 rounded-lg border-[1px] border-gray02 px-4 py-3">
      <div className="flex items-center gap-2">
        <div
          className={'h-fit w-fit rounded-3xl px-2 py-1'}
          style={{ background: config.bg }}
        >
          <p
            className={'text-xs font-semibold '}
            style={{ color: config.color }}
          >
            {config.label}
          </p>
        </div>
      </div>
      <Dialog>
        <DialogTrigger disabled={config.disabled}>
          <div className="flex items-center gap-3">
            {isEmpty ? (
              <p className="text-sm text-black04">
                Selecione um {config.label}
              </p>
            ) : (
              <>
                <BasicAvatar
                  name={executive.name}
                  profileImageUrl={executive.profileImageUrl}
                />
                <p className="text-sm font-semibold">
                  {formatName(executive.name)}
                </p>
              </>
            )}
          </div>
        </DialogTrigger>
        {isEmpty ? (
          config.dialog
        ) : (
          <RemoveExecutive executive={executive.name} team={team} role={type} />
        )}
      </Dialog>
    </div>
  )
}
